import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  width: 320px;
  padding: 20px;
  flex-direction: column;
  gap: 12px;
  border-radius: 8px;
  background: white;
  box-sizing: border-box;
  box-shadow: var(--alias-style-shadow-strong);

  position: absolute;
  z-index: 100;
`;

export const EmptyImage = styled.div`
  display: flex;
  width: 120px;
  height: 120px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  border-radius: 4px;
  background: var(--component-color-fill-alternative);
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;
